import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";
import chatbotData from "./chatbotData";

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
  const handleOptionClick = (nextId) => {
    const node = chatbotData[nextId];

    if (node.options) {
      // If node has options → show message + buttons
      const message = createChatBotMessage(node.message, {
        widget: "options",
        payload: { options: node.options },
      });

      setState((prev) => ({
        ...prev,
        messages: [...prev.messages, message],
        currentId: nextId,
      }));
    } else {
      // If final answer → show plain text      
      const message = createChatBotMessage(
        "",
        {
          widget: "renderHTML",
          payload: node.message,
          isCustom: true, 
          customTypeName: "html",
        }
      )
      setState((prev) => ({
        ...prev,
        messages: [...prev.messages, message],
        currentId: nextId,
      }));
    }
  };

  return (
    <>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { actions: { handleOptionClick } })
      )}
    </>
  );
};

export default ActionProvider;
